module.exports = __webpack_public_path__ + "static/media/ecuacovid.7d06d4c6.PNG";